import { render, staticRenderFns } from "./LLMConfiguration.vue?vue&type=template&id=bebf3704&scoped=true"
import script from "./LLMConfiguration.vue?vue&type=script&lang=js"
export * from "./LLMConfiguration.vue?vue&type=script&lang=js"
import style0 from "./LLMConfiguration.vue?vue&type=style&index=0&id=bebf3704&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebf3704",
  null
  
)

export default component.exports